export default {
  onlinePay: '在线支付',
  selectPaymethod: '选择支付方式',
  documentTitle: '我的奖品',
  goPayment: '去付款',
  waitPay: '待付款',
  specification: '规格',
  customize: '多规格',
  optional: '可选',
  required: '必选',
  addToCart: '加入购物车',
  theStoreIsClosed: '门店休息中',
  businessHours: '营业时间',
  mon: '星期一',
  tues: '星期二',
  wed: '星期三',
  thur: '星期四',
  fri: '星期五',
  sat: '星期六',
  sun: '星期日',
  categories: '分类',
  viewCart: '查看购物车',
  toSettle: '去结算',
  clearAll: '清空',
  sureClearAll: '确定要清空购物车吗?',
  del_product: '确定不要了吗?',
  total: '总计',
  subtotal: '合计',
  paymentMethod: '付款方式',
  cash: '现金',
  VAT: '增值税',
  orderSubmit: '立即下单',
  submitSuccessfully: '提交成功！',
  orderNumber: '订单号',
  orderTime: '订单创建时间',
  payTime: '支付时间',
  reason: '原因',
  cancelled: '已取消',
  completed: '已完成',
  paymentTitle: 'Payment Result',
  know: '我知道了',
  inclVAT: '包含增值税',
  noWownowTip: '打开WOWNOW APP 点餐',
  stopTip: '该店未开始营业',
  table: '桌台号',
  orderCode: '取餐码',
  checkout: '下单',
  placeOrder: '去下单',
  waitingTip: '等待商家确认订单',
  merchantsTip: '商家会尽快接单',
  cancelledTip: '抱歉，您的订单已被取消，请与商家沟通具体原因',
  waitPayTip: '您的订单已提交，请及时付款！',
  completedTip: '你的订单完成，请享用吧！',
  orderSummary: '商品清单',
  maxTip: '最多可选 {count} 项',
  copySuccess: '复制成功',
  copyFail: '复制失败',
  pullDownToRefresh: "下拉即可刷新...",
  releaseToRefresh: "释放即可刷新...",
  loadingText: "加载中...",
  noTableTip: '桌台号无效，请重新扫码',
  notOrder: '以下商品已下架不可购买，请重新确定',
  orderDetail: '订单详情',
  cart: '购物车',
  orderListTitle: '我的订单',
  wait: '待接单',
  orderShowDown: '已显示全部订单',
  amount: '数量',
  noOrder: '暂无订单，赶紧去下单吧！',
  orderList: '订单列表',
  remark: '订单备注',
  paymentChannelOrder: '支付渠道订单',
  showOrderDetail: '查看订单详情',
  successTitle: '成功支付',
  downloadTips: '请下载APP后,使用WowNow APP下单',
  orderCreated: '当前桌台已生成订单',
  shoppingCartChangeTip: '购物车信息已变更!',
  loginTips: '登录WOWNOW帐号可获得更好的用户体验',
  mustLogin: '门店仅支持在线支付，请登录后下单',
  goLogin: '去登录',
  confirmOrder: '确认订单',
  login: '登录',
  logined: '登录成功',
  canUse: '后可使用在线支付',
  ordering: '直接下单',
  confirm: '确认',
  cancel: '取消',
  tips: '提示',
  cartExpired: '购物车信息已过期',
  seletedPropertyText: '已选规格属性',
  changeLang: '选择语言',
  needDownloadWownow: '需下载wownow APP',
  limit99copies: '每件商品限制99份',
  samePropertyLimit99: '相同规格或属性的商品限制99份，当前数量：{current}',
  plsSelectPayMethod: '请先选择支付方式',
  zh: '中文',
  en: 'English',
  km: '柬文'
}
